import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Route-change scroll behaviour.
 *
 * Landing on a new page should start at the top; landing on a page *with* a
 * hash (e.g. `/#showroom` from the legal pages) should land on that section.
 * The jump is done with `behavior: 'auto'` because `html { scroll-behavior:
 * smooth }` would otherwise animate a full-page scroll on every navigation.
 */
export function ScrollManager() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      // The target may not be mounted on the very first paint.
      const target = document.getElementById(hash.slice(1));
      if (target) {
        target.scrollIntoView({ behavior: 'auto', block: 'start' });
        return;
      }
    }
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname, hash]);

  return null;
}

export default ScrollManager;
